module.exports = __webpack_public_path__ + "media/img/use-ico-1-100776d0b7922d648c118b06aaaafa6d.svg";